import React, { useEffect } from "react";

interface YoutubeModalProps {
    videoId: string | null;
    onClose: () => void;
}

const YoutubeModal: React.FC<YoutubeModalProps> = ({ videoId, onClose }) => {
    useEffect(() => {
        if (!videoId) return;
        const handleKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleKey);
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", handleKey);
            document.body.style.overflow = "";
        };
    }, [videoId, onClose]);

    if (!videoId) return null;

    const isShort = videoId.length < 12;
    const embedSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75" onClick={onClose} role="dialog" aria-modal="true" aria-label="Video player">
            <div className="relative w-full max-w-3xl mx-4" style={{ aspectRatio: isShort ? "9/16" : "16/9", maxHeight: "80vh" }} onClick={(e) => e.stopPropagation()}>
                <button onClick={onClose} className="absolute -top-10 right-0 text-white text-3xl leading-none hover:text-gray-300 transition-colors" aria-label="Close video">
                    &times;
                </button>
                <iframe src={embedSrc} className="w-full h-full rounded-lg" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen title="YouTube video" />
            </div>
        </div>
    );
};

export default YoutubeModal;
